export const setLocalUsers = (newUsers) => {
  const users = getLocalUsers()
  Object.values(newUsers).forEach(user => {
    users[user.mailNickname] = { ...user, lastUpdate: new Date() }
  })
  localStorage.setItem('users', JSON.stringify(users))
}

export const getLocalUsers = () => {
  return JSON.parse(localStorage.getItem('users')) || {}
}
